<template>
  <container>
     <h1 style="font-size:25px;marging-top:20px;margin-bottom:30px;text-align:center">Total Participants</h1>
     <div style="margin-bottom:80px">
            <date-range-field v-model="rangeData"></date-range-field>
     </div>
    <div class="tp-table">
        <v-table
          :is-loading="loading"
           is-horizontal-resize
          :columns="columns"
          style="width:100%;font-size:11px"
          :table-data="tableData"
          :show-vertical-border="true"
          :title-row-height ="30"
          :border="1"    
          :footer="footer"  
          :footer-row-height="40"   
          :footer-cell-class-name="setFooterCellClass"
          row-hover-color="#eee"
          :row-click = "raceDetail"     
        ></v-table>

        <div class="mt20 mb20 bold" style="padding-top:25px">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="pageTotal" :pageIndex ="pageIndex+1" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
      </div>


        </div>

  </container>
</template>
<script>
import Container from "@/components/Container"
import DateRangeField from '@/components/Forms/DateRangeField'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
export default {
  name: "tp",
  data() {
    return {

      columns: [
                // {field: "date", title:'Date', width: 100, titleAlign: 'center',columnAlign:'center', isFrozen: true,},
                // {field: "date", title:'Date', width: 100, titleAlign: 'center',columnAlign:'center', formatter: function (rowData,rowIndex,pagingIndex,field) {
                //                 return rowData.date.split("T")[0]
                // },isFrozen: true},
                {field: "date", title:'Date', width: 100, titleAlign: 'center',columnAlign:'center',isFrozen: true,componentName:'date-format'},
                {field: "name", title:'Session Title', width: 250, titleAlign: 'center',columnAlign:'center',isResize:true},
                {field: "TrainerName", title:'Trainer', width: 120, titleAlign: 'center',columnAlign:'center',},
                //{field: "total_amount_runners", title:'TP', width: 100, titleAlign: 'center',columnAlign:'center', },
                {field: "TP", title:'TP', width: 100, titleAlign: 'center',columnAlign:'center', },
                {field: "question", title:'Question', width: 500, titleAlign: 'center',columnAlign:'center',isResize:true},
      ],
      footer:[[]],
      tableData :[],
      pageIndex:0,
      pageTotal:null,
      pageSize:10,       
      rangeData:{
        startDate: moment().startOf('month').startOf('day').toISOString(),
        endDate:  moment().endOf('month').endOf('day').toISOString(),
      },
      loading:false,
            
    }
  },
  computed: {
  },
  methods: {
    intialize(){
      this.getTotalParticipants(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex,this.pageSize)   
    },
    getTotalParticipants(startDate,endDate,pageIndex,pageSize){
      this.loading=true
      const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
      //axios.get(`http://localhost:3007/getTotalParticipants?startDate=`+startDate+`&endDate=` + endDate +`&pageIndex=`+pageIndex+`&pageSize=`+pageSize+`&staging=`+this.$isStage, { headers: { Authorization: AuthStr } })
      axios.get(this.$expressApi+`getTotalParticipants?startDate=`+startDate+`&endDate=` + endDate +`&pageIndex=`+pageIndex+`&pageSize=`+pageSize+`&staging=`+this.$isStage, { headers: { Authorization: AuthStr } })
        .then(response => {  
          console.log("resp----",response.data)
          this.tableData=response.data.content
          this.pageTotal = response.data.totalElements
          if(this.tableData.length>0){
            this.footer=[['Total','','',response.data.totalTp,'']]
          }else{
            this.footer=[]
          }
          this.loading=false
        },error=>{
            this.tableData=[]
            console.log("error",error)
            this.loading=false
        })       
    },
    pageChange(pageIndex){
      this.pageIndex = pageIndex-1
      this.getTotalParticipants(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex,this.pageSize)        
    },
     pageSizeChange(pageSize){
      this.pageIndex = 0
      this.pageSize = pageSize
      this.getTotalParticipants(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex, this.pageSize)        
    },
    raceDetail(newValue,raceData){
      let route = this.$router.resolve({
        name: 'past-run',
        params: { pastRun: true, raceId: raceData.raceId }
      })
      window.open(route.href, '_blank')

    },
    setFooterCellClass(rowIndex, colIndex, value){
      if (colIndex === 0) {
          return 'footer-cell-class-name-title'
      } else {
       return 'footer-cell-class-name-normal'
      }
    }    
  },
  created() {
    this.intialize()
  },
  watch: {
     rangeData(oldVal, newVal) {
            this.pageIndex = 0
            this.pageSize= 10
            this.intialize()
            //console.log(oldVal,"---newVal---",newVal)            
            //console.log(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex,this.pageSize)
        }
  },
  components: {
    Container,
    DateRangeField
  }
}

Vue.component('date-format',{
        template:`<span>
                    {{newdate}}
                  </span>`,
        data: () => ({
        newdate: ''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          initdata(){
            //  this.newdate= moment(this.rowData.date).format('YYYY-MM-DD')
            this.newdate= moment(this.rowData.start_date).format('YYYY-MM-DD')             
          }
        },
       created () {
          this.initdata()
        },
        watch: {
          rowData: function (val) {
            this.initdata()
          }
        },
})
</script>

<style>
.tp-table tr.v-table-header-row {
    background: #423799;
    color: white;
    font-size: 12px;
    font-weight: bold;
}

.tp-table tr.v-table-row {
    cursor: pointer;
}

.footer-cell-class-name-title {
  background-color: #f60;
  color: #fff;
  font-size: 14px;
}
.footer-cell-class-name-normal {
    color: red;
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// TP.vue?45f2f59d